import { META_EXPRESSION_SCOPE, TRIGGER_EVENT } from "fieldpro-tools";

import { IList } from "model/entities/List";
import { ITrigger } from "model/entities/Trigger";
import { IActivity } from "model/entities/Workflow";

interface IScopeResources {
  currentStepId?: string;
  currentActivity?: IActivity;
  currentList?: IList;
  currentTrigger?: ITrigger;
}

export const getResourceIdForScope = (
  scope: META_EXPRESSION_SCOPE | undefined,
  {
    currentStepId,
    currentActivity,
    currentList,
    currentTrigger,
  }: IScopeResources,
): string | undefined => {
  switch (scope) {
    case META_EXPRESSION_SCOPE.ITEM:
      return currentList?.id;

    case META_EXPRESSION_SCOPE.ACTIVITY_REPORT:
    case META_EXPRESSION_SCOPE.WORKFLOW_REPORT:
    case META_EXPRESSION_SCOPE.MATRIX_CELL:
    case META_EXPRESSION_SCOPE.ITEM_CELL:
      return currentStepId ?? currentActivity?.id;

    case META_EXPRESSION_SCOPE.TRANSFORMATION:
    case META_EXPRESSION_SCOPE.INTEG_RECORD:
      return currentStepId;

    case META_EXPRESSION_SCOPE.CUSTOMER:
      return "customer";

    case META_EXPRESSION_SCOPE.TRIGGER_EVENT:
      switch (currentTrigger?.event_type) {
        case TRIGGER_EVENT.WEBHOOK_EVENT:
          return currentTrigger?.webhook_id;
        case TRIGGER_EVENT.FIELDPRO_CREATE_ITEM:
        case TRIGGER_EVENT.FIELDPRO_EDIT_ITEM:
        case TRIGGER_EVENT.FIELDPRO_VALIDATE_CREATED_ITEM:
        case TRIGGER_EVENT.FIELDPRO_EDIT_VALIDATED_ITEM:
          return currentTrigger?.list_id;
        case TRIGGER_EVENT.FIELDPRO_CREATE_ITEM_UPLOAD:
          return currentTrigger?.list_id;
        case TRIGGER_EVENT.FIELDPRO_CREATE_ACTIVITY_REPORT_UPLOAD:
          return currentTrigger?.activity_id;
        case TRIGGER_EVENT.FIELDPRO_ACTIVITY_REPORT_FULLY_SYNCED:
          return currentTrigger?.activity_id;
        default:
          return undefined;
      }

    default:
      return currentStepId ?? currentActivity?.id ?? currentList?.id;
  }
};

export default getResourceIdForScope;
